<template>
	<div class="alert" v-prevent-overscroll>
		<div class="alert-area">
			<div class="view-figure-wrapper" :style="baseStyle">
				<div class="view-figure-content" :style="figureStyle">
					<img class="view-figure-img" :src="info.$$opts.cardImage" alt="" />
				</div>
				<div class="close-btn" :style="closeStyle" @click.stop="closeView">
				</div>
				<div class="share-btn" :style="shareStyle" @click.stop="shareCard">
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {

	name: "viewCard",

	props: {
		info: { // 查看卡片信息
			type: Object,
			required: true,
			default: () => {
				return {}
			}
		},
	},

	watch: {
		info: {
			handler(val) {
				if (val) {
					// this.initStyle(val)
				}
			},
			deep: true
		}
	},

	data() {

		return {

			baseStyle: { // 基础配置样式

			},

			figureStyle: { // 人物卡片样式

			},

			closeStyle: { // 关闭按钮样式

			},

			shareStyle: { // 分享按钮样式

			}

		};

	},

	mounted() {

		this.initStyle(this.info)

	},

	methods: {

		initStyle(val) { // 初始化样式

			let config = val.viewConfig

			let { base, close, figure, share } = config

			let transform = (config, imgKey) => {

				let options = {}

				if (config.width) {
					options.width = `${config.width}px`
				}

				if (config.height) {
					options.height = `${config.height}px`
				}

				if (config.position1 && config.position1.type) {
					options[`${config.position1.type}`] = `${config.position1.value || 0}px`
				}

				if (config.position2 && config.position2.type) {
					options[`${config.position2.type}`] = `${config.position2.value || 0}px`
				}

				if (imgKey) {
					if (config[imgKey] && config[imgKey].url) {
						let background = {
							backgroundImage: `url(${config[imgKey].url})`,
							backgroundSize: `100% 100%`,
							backgroundPosition: '0px 0px',
						}
						options = Object.assign(options, background)
					}
				}

				return options

			}

			this.baseStyle = base && transform(base, 'img') || {}
			this.closeStyle = close && transform(close, 'img') || {}
			this.figureStyle = figure && transform(figure, 'background') || {}
			this.shareStyle = share && transform(share, 'img') || {}

		},

		closeView() { // 关闭查看卡片
			this.$emit('emitEvent', {
				type: 'closeViewCard',
				data: null,
				options: null
			})
		},

		shareCard() { // 分享卡片
			this.$emit('emitEvent', {
				type: 'shareViewCard',
				data: this.info.$$opts,
				options: null
			})
			this.$emit('emitEvent', {
				type: 'closeViewCard',
				data: null,
				options: null
			})
		}

	},
};
</script>

<style scoped lang="scss">
.alert {
	position: fixed;
	width: 100%;
	height: 100vh;
	top: 0;
	left: 0;
	z-index: 100;
	background: rgba(0, 0, 0, 0.8);
}

.alert .alert-area {
	height: 100%;
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
}

.view-figure-wrapper {
	position: relative;

	.view-figure-content {
		position: absolute;
		z-index: 1;
	}

	.view-figure-img {
		width: 100%;
		height: 100%;
	}

	.close-btn {
		z-index: 2;
		position: absolute;
	}

	.share-btn {
		z-index: 2;
		position: absolute;
	}
}
</style>